<template>
  <v-card class="mt-0 mb-0" tile flat max-width="600">
    <v-system-bar color="primary" dark v-if="header !== false">
      <span class="white--text">{{header}}</span>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-system-bar>
    <v-card-text class=" black--text pa-0">
      <v-row justify="start" align="start" no-gutters class="">
        <v-col cols="12">
          <v-menu
            v-model="date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="value"
                label="Дата"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :value="value"
              @input="setValue"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { dtUtilsMixin } from '@/components/modules/mixins/datetimeUtils'

export default {
  name: 'sysDatePanel',
  emits: ['input'],
  mixins: [dtUtilsMixin],
  props: {
    header: {
      type: [String, Boolean],
      default: 'Дата'
    },
    noFuture: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      maxDate: null,
      date_menu: false
    }
  },
  mounted () {
    console.log('sysDatePanel mounted with currenDate ', this.value)
    if (this.noFuture) {
      this.maxDate = this.today()
    }
    if (!this.value) {
      this.setValue(this.today())
    }
  },
  watch: {},
  methods: {
    setValue (val) {
      this.$emit('input', val)
      this.date_menu = false
    }
  }
}
</script>

<style scoped>
</style>
